import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineChevronLeft } from 'react-icons/hi';
import { useAuth } from '../../context/AuthContext';
import { hasCardAction } from '../../utils/permissionHelper';
import UsersTab from './components/UsersTab';
import CustomersTab from './components/CustomersTab';
import UploadTab from './components/UploadTab';
import TemplatesTab from './components/TemplatesTab';
import LogsTab from './components/LogsTab';
import './AgingReports.css';

const AgingReports = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState('customers');

    // Permission checks
    const userPermissions = user?.permissions || { cards: [], actions: [] };
    const canEdit = user?.role === 'system_admin' || hasCardAction(userPermissions, 'aging-reports', 'edit');
    const canDelete = user?.role === 'system_admin' || hasCardAction(userPermissions, 'aging-reports', 'delete');
    const canCreate = user?.role === 'system_admin' || hasCardAction(userPermissions, 'aging-reports', 'create');

    const tabs = [
        { id: 'customers', label: 'Customers', icon: '👥' },
        { id: 'upload', label: 'Upload Reports', icon: '📤' },
        { id: 'templates', label: 'Templates', icon: '📝' },
        { id: 'logs', label: 'Email Logs', icon: '📧' },
        { id: 'users', label: 'Email Users', icon: '⚙️' }
    ];

    return (
        <div className="ar-shell">
            {/* HEADER */}
            <header className="ar-header">
                <div className="ar-header-left">
                    <button className="ar-back-btn" onClick={() => navigate('/purpose')}>
                        <HiOutlineChevronLeft size={20} />
                    </button>
                    <div className="ar-header-title">
                        <h1>Aging Reports</h1>
                        <span>Module</span>
                    </div>
                </div>
            </header>

            {/* NAVIGATION TABS */}
            <nav className="ar-nav">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`ar-nav-tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <span className="ar-nav-tab-icon">{tab.icon}</span>
                        {tab.label}
                    </button>
                ))}
            </nav>

            {/* BODY */}
            <div className="ar-body">
                <main className="ar-content">
                    {activeTab === 'customers' && (
                        <CustomersTab 
                            canEdit={canEdit} 
                            canDelete={canDelete} 
                            canCreate={canCreate}
                        />
                    )}
                    {activeTab === 'upload' && (
                        <UploadTab canCreate={canCreate} />
                    )}
                    {activeTab === 'templates' && (
                        <TemplatesTab
                            canCreate={canCreate}
                            canDelete={canDelete}
                            canEdit={canEdit}
                        />
                    )}
                    {activeTab === 'logs' && (
                        <LogsTab />
                    )}
                    {activeTab === 'users' && (
                        <UsersTab 
                            canEdit={canEdit} 
                            canDelete={canDelete} 
                            canCreate={canCreate}
                        />
                    )}
                </main>
            </div>
        </div>
    );
};

export default AgingReports;
